export default __webpack_public_path__ + "54851dc3f5ada849af04e2079dd89d30.woff2";